import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ContactTemp } from './contact-temp.model';
import { ContactTempPopupService } from './contact-temp-popup.service';
import { ContactTempService } from './contact-temp.service';

@Component({
    selector: 'jhi-contact-temp-delete-dialog',
    templateUrl: './contact-temp-delete-dialog.component.html'
})
export class ContactTempDeleteDialogComponent {

    contactTemp: ContactTemp;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private contactTempService: ContactTempService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.contactTempService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'contactTempListModification',
                content: 'Deleted an contactTemp'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-contact-temp-delete-popup',
    template: ''
})
export class ContactTempDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private contactTempPopupService: ContactTempPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.contactTempPopupService
                .open(ContactTempDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/contact-temp-delete-dialog.component.ts